import { render, staticRenderFns } from "./HomeBetContent.vue?vue&type=template&id=004e9098&scoped=true&"
import script from "./HomeBetContent.vue?vue&type=script&lang=js&"
export * from "./HomeBetContent.vue?vue&type=script&lang=js&"
import style0 from "./HomeBetContent.vue?vue&type=style&index=0&id=004e9098&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004e9098",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('004e9098')) {
      api.createRecord('004e9098', component.options)
    } else {
      api.reload('004e9098', component.options)
    }
    module.hot.accept("./HomeBetContent.vue?vue&type=template&id=004e9098&scoped=true&", function () {
      api.rerender('004e9098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/HomeBetContent.vue"
export default component.exports